/**
 * JavaScript related to user register.
 */
function setupPrevNext () {
  const registerNextButton = document.querySelector('.js-register-next')
  const registerPrevButton = document.querySelector('.js-register-prev')

  const firstPart = [...document.querySelectorAll('.js-register-first')]
  const secondPart = [...document.querySelectorAll('.js-register-second')]

  // User has javascript, hide second part and unhide nav buttons
  secondPart.forEach(part => {
    part.classList.add('is-hidden')
  })

  registerNextButton.classList.remove('is-hidden')
  registerPrevButton.classList.remove('is-hidden')

  const events = ['mousedown', 'ontouchstart', 'click']

  // Add navigation for buttons
  events.forEach(evt => {
    registerNextButton.addEventListener(evt, () => {
      const validationResult = validateFirstPart()
      if (!validationResult) return false

      firstPart.forEach(part => {
        part.classList.add('is-hidden')
      })
      secondPart.forEach(part => {
        part.classList.remove('is-hidden')
      })
    })

    registerPrevButton.addEventListener(evt, () => {
      secondPart.forEach(part => {
        part.classList.add('is-hidden')
      })
      firstPart.forEach(part => {
        part.classList.remove('is-hidden')
      })
    })
  })


}

function validateBasicField (field) {
  return field.value !== ''
}

function validateEmailField (field) {
  let status = true
  if (field.value === '') status = false
  if (!field.value.includes('@')) status = false
  return status
}

function validatePasswordField (field) {
  let status = true
  if (field.value === '') status = false
  if (field.classList.contains('js-password')) {
    if (field.value.length < 6) status = false
  } else if (field.classList.contains('js-password-confirm')) {
    const pass = document.querySelector('.js-password')
    if (pass.value !== field.value) status = false
  }

  return status
}

function validatePasswordConfirm (field) {
  let status = true
  if (field.value === '') status = false
  if (field.value.length < 6) status = false
  return status
}

function validateCheckbox (field) {
  return field.checked
}

function validateField (field, evt) {
  let status = true
  switch (field.type) {
    case 'password':
      status = validatePasswordField(field)
      break
    case 'email':
      status = validateEmailField(field)
      break
    case 'checkbox':
      status = validateCheckbox(field)
      break
    case 'text':
    case 'select-one':
    default:
      status = validateBasicField(field)
      break
  }

  if (!status) {
    field.classList.add('Input--error')
    field.parentNode.querySelector('.FormValidation').classList.remove('is-hidden')
  } else {
    field.classList.remove('Input--error')
    field.parentNode.querySelector('.FormValidation').classList.add('is-hidden')
  }
  return status
}

function setupValidation (form) {
  const fields = form.querySelectorAll('.js-validate')
  fields.forEach(field => {
    if (field.type === 'select-one') {
      field.addEventListener('change', (evt) => {
        validateField(field, evt)
      })
    } else if (field.type === 'checkbox') {
      field.addEventListener('click', (evt) => {
        validateField(field, evt)
      })
    } else {
      field.addEventListener('blur', (evt) => {
        validateField(field, evt)
      })
    }
  })

  form.addEventListener('submit', (evt) => {
    let status = true
    fields.forEach(field => {
      const fieldStatus = validateField(field)
      if (!fieldStatus) { status = false }
    })
    if (!status) evt.preventDefault()
  })
}

function validateFirstPart () {
  let status = true
  const firstPart = document.querySelector('.js-form-first')
  const fields = firstPart.querySelectorAll('.js-validate')
  fields.forEach(field => {
    const fieldStatus = validateField(field)
    if (!fieldStatus) { status = false }
  })
  return status
}

export default function registerForm () {

  const registerForm = document.getElementById('registerform')
  if (registerForm) {
    setupPrevNext()
    setupValidation(registerForm)
  }
}
